import { Fragment, useState, useRef } from "react";
// import * as Yup from "yup";s
// import { useFormik } from "formik";
import { AiOutlineClose } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import BottomButton from "../../DocButtomButton";
import CustomInput from "../../../components/CustomInput";
// import ErrorInputComponent from "../../ErrorInputComponent";
import { hideModal } from "../../../actions/modal.action";
import {
  fetchChatStudentsInfo,
  addChatUser,
} from "../../../actions/chat.action";
import UserSelectTab from "./UserSelectTab";

export default function FindChatStudentModal() {
  const dispatch = useDispatch();
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(true);
  const [receiverId, setReceiverId] = useState("");

  const {
    chat: { usersInfoList, friendsLoading },
  } = useSelector(({ chatReducer }) => ({
    chat: chatReducer,
  }));

  const closeModal = () => {
    setOpen(false);
    dispatch(hideModal());
  };

  const handleSubmit = () => {
    if (receiverId.trim() !== "") {
      dispatch(addChatUser(receiverId));
    }
  };

  const handleUserFetch = (fullName) => {
    dispatch(fetchChatStudentsInfo(fullName));
  };

  const handleSelect = (id) => {
    setReceiverId(id);
  };

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={closeModal}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-cente justify-center min-h-full p-4 text-cente sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                  <div className="">
                    <div className="">
                      <div className="mb-6 bg-gray-800 p-4 rounded-t-md">
                        <div className="flex text-xl items-center text-white">
                          <AiOutlineClose
                            onClick={() => closeModal()}
                            className="cursor-pointer"
                          />
                          <div className="ml-auto mr-auto font-bold">
                            New Message
                          </div>
                        </div>
                      </div>
                      <div className="mt-10 sm:px-6 px-6 w-full">
                        <form>
                          <div className="w-full">
                            <CustomInput
                              handleChange={(e) =>
                                handleUserFetch(e.target.value)
                              }
                              name="fullName"
                              placeholder="Enter Student Name"
                              type="text"
                            />
                            {/* <ErrorInputComponent error={errors.fullName} /> */}
                          </div>
                          <UserSelectTab
                            userList={usersInfoList}
                            onSelect={handleSelect}
                          />
                        </form>
                      </div>
                      <BottomButton
                        name={"Chat"}
                        func={handleSubmit}
                        loading={friendsLoading}
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
